export default "__VITE_ASSET__BhN_KKtr__"